import { Switch } from 'components/switch';
import { lazy, Suspense } from 'react';
import { useRecoilValue } from 'recoil';
import { meetingTemplateAtom } from '_state/signature';
// import MeetingTemplateOne from './MeetingTemplateOne';
// import MeetingTemplateTwo from './MeetingTemplateTwo';

const MeetingTemplateOne = lazy(() => import('./meetingTemplateOne'));
const MeetingTemplateTwo = lazy(() => import('./meetingTemplateTwo'));
const MeetingTemplateThree = lazy(() => import('./meetingTemplateThree'));

const RenderMeetingViewTemplate = () => {
  const meetingTemplate = useRecoilValue(meetingTemplateAtom);

  return (
    <Suspense fallback={<></>}>
      <Switch switchCase={meetingTemplate}>
        <MeetingTemplateOne value="template1" />
        <MeetingTemplateTwo value="template2" />
        <MeetingTemplateThree value="template3" />
      </Switch>
    </Suspense>
  );
};

export default RenderMeetingViewTemplate;
